import styled from '@emotion/styled'

import { DEFAULT_THEME_COLORS, DEFAULT_FONT_STYLES } from 'css/theme'

export type CaptionProps = {
  errored?: boolean
}

const Caption = styled.span(({ errored }: CaptionProps) => ({
  display: 'flex',
  alignItems: 'flex-start',
  color: errored
    ? DEFAULT_THEME_COLORS['--theme-color--status-error']
    : DEFAULT_THEME_COLORS['--theme-color--neutral-30'],
  fontSize: DEFAULT_FONT_STYLES['--theme-font--caption__font-size'],
  lineHeight: DEFAULT_FONT_STYLES['--theme-font--caption__line-height'],
  fontWeight: DEFAULT_FONT_STYLES['--theme-font--caption__font-weight'],
  gap: '2px',
  svg: {
    transform: 'scale(1.5)',
  },
}))

export default Caption
